import { useParams } from 'react-router-dom';
import EditOfferingForm from './EditOfferingForm';

import Page from '@/components/layout/Page';
import PageLoading from '@/components/layout/PageLoading';
import BackButton from '@/components/common/BackButton';
// import HorizontalLogo from '@/components/common/HorizontalLogo';

import { useQuery } from '@/helpers/useQuery';

// import { useCoachActivity } from '@/data/coachActivity';
import { useOfferingCategories } from '@/data/offeringCategory';
import { useOffering } from '@/data/offering';
import { useRegions } from '@/data/region';

const EditOfferingPage = () => {
  const backTo = useQuery('backTo');
  const params = useParams();
  // const coachActivity = useCoachActivity(coachActivityId);
  const offering = useOffering(params.id);
  const offeringCategories = useOfferingCategories();
  const regions = useRegions();

  if (offering.isLoading && !offering.data) {
    return <PageLoading />;
  }
  if (offeringCategories.isLoading && !offeringCategories.data) {
    return <PageLoading />;
  }
  if (regions.isLoading && !regions.data) {
    return <PageLoading />;
  }

  return (
    <Page>
      <BackButton to={backTo} />
      <div className="p-6 text-center">
        <h1 className="text-3xl font-bold mb-2">Edit {offering.data.name}</h1>
        <p className="text-muted-foreground">{offering.data.activity.title}</p>
      </div>
      <EditOfferingForm />
      <div className="flex justify-center py-8"></div>
    </Page>
  );
};

export default EditOfferingPage;
